import {
  PRE_SELECTED_FILTERS,
  PRE_SELECTED_ADVANCED_FILTERS,
} from '@alumni_v2/data/preSelectedFilter';

const DSML_QUICK_FILTER = 'data_science_&_ml';
const DSML_URL_PATH = '/data-science-course/reviews/';
const AIML_QUICK_FILTER = 'artificial_intelligence_&_ml';
const AIML_URL_PATH = '/ai-machine-learning-course/reviews/';

const extractKeywordsFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const keywords = urlParams.getAll('keywords');

  return keywords?.length > 0 ? keywords : [];
};

const reconstructFiltersFromQuery = (queryString) => {
  const preSelectedAdvancedFilters = window.sessionStorage
    .getItem(PRE_SELECTED_ADVANCED_FILTERS);
  const preSelectedFiltersJson = JSON.parse(preSelectedAdvancedFilters) || {};

  const urlParams = new URLSearchParams(queryString);
  const advancedKeywords = urlParams.getAll('advanced_keyword');

  const filters = {};

  if (!advancedKeywords || advancedKeywords.length === 0) {
    return { ...preSelectedFiltersJson };
  }

  advancedKeywords.forEach((value) => {
    const parts = value.split(',').map(decodeURIComponent);
    const filterKey = parts[0];

    if (!filters[filterKey]) {
      filters[filterKey] = [];
    }

    if (filterKey === 'experience' || filterKey === 'growth') {
      const filterObject = {};
      parts.slice(1).forEach((part) => {
        const [key, val] = part.split('=');
        filterObject[key] = val;
      });
      filters[filterKey].push(filterObject);
    } else {
      const filterValue = parts[1];
      if (filterValue) {
        filters[filterKey].push(filterValue);
      }
    }
  });

  return { ...preSelectedFiltersJson, ...filters };
};

export const getPreSelectedFilters = () => {
  const preSelectedFilters = window.sessionStorage
    .getItem(PRE_SELECTED_FILTERS);
  const preSelectedFiltersJson = JSON.parse(preSelectedFilters) || [];
  const extractedKeywords = extractKeywordsFromURL();
  const filteredExtractedKeywords = extractedKeywords
    .filter(keyword => !preSelectedFiltersJson?.includes(keyword));
  preSelectedFiltersJson.push(...filteredExtractedKeywords);

  if (window.location.pathname === DSML_URL_PATH) {
    if (!preSelectedFiltersJson?.includes(DSML_QUICK_FILTER)) {
      preSelectedFiltersJson.push(DSML_QUICK_FILTER);
    }
  } else if (window.location.pathname === AIML_URL_PATH) {
    if (!preSelectedFiltersJson?.includes(AIML_QUICK_FILTER)) {
      preSelectedFiltersJson.push(AIML_QUICK_FILTER);
    }
  }

  const sharedFilter = reconstructFiltersFromQuery(window.location.search);

  return { preSelectedFiltersJson, sharedFilter };
};
